import "aws-amplify/auth/enable-oauth-listener";
import { StrictMode } from "react";
import "./styles/index.css";
import "react-image-crop/dist/ReactCrop.css";
import ReactDOM from "react-dom/client";
import { RouterProvider, createRouter } from "@tanstack/react-router";
import { AllCommunityModule, ModuleRegistry } from "ag-grid-community";
import "./lib/datadog.ts";
import { addReactError } from "@datadog/browser-rum-react";
import DefaultErrorPage from "@/components/errors/DefaultErrorPage.tsx";
import NotFoundPage from "@/components/errors/NotFoundPage.tsx";
import { Amplify } from "aws-amplify";
import { amplifyConfig } from "@/amplify-config";

// Import the generated route tree
import { routeTree } from "./routeTree.gen";

Amplify.configure(amplifyConfig);

// CloudFront's default root object rewrites "/" to "/index.html" before
// forwarding to Prerender.io, causing TanStack Router to show a 404.
// Fix the pathname before the router initializes so "/" matches correctly.
if (window.location.pathname === "/index.html") {
  window.history.replaceState(null, "", "/");
}

// Create a new router instance
const router = createRouter({
  routeTree,
  defaultErrorComponent: DefaultErrorPage,
  defaultNotFoundComponent: NotFoundPage,
  scrollRestoration: true,
  scrollToTopSelectors: [".main-scroll-container"],
});

// Register all Community features
ModuleRegistry.registerModules([AllCommunityModule]);

// Register the router instance for type safety
declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

// Render the app
const rootElement = document.getElementById("root")!;
if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement, {
    onUncaughtError: (error, errorInfo: React.ErrorInfo) => {
      // Report uncaught errors to Datadog
      addReactError(error as Error, errorInfo);
    },
    onCaughtError: (error, errorInfo: React.ErrorInfo) => {
      // Report caught errors to Datadog
      addReactError(error as Error, errorInfo);
    },
    onRecoverableError: (error, errorInfo: React.ErrorInfo) => {
      // Report recoverable errors to Datadog
      addReactError(error as Error, errorInfo);
    },
  });

  root.render(
    <StrictMode>
      <RouterProvider router={router} />
    </StrictMode>,
  );
}
